import { mobileAssets } from 'src/containers/PreCache'
import styled from 'styled-components'

export const OnDemandStyle = styled.div`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 77px;
  overflow: hidden;
  background: #c9d9e3 url(${mobileAssets.dashboardBg}) center / cover no-repeat;
  color: #fff !important;
  font-family: 'Din', 'DIN', sans-serif;

  .page-layout {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: transparent;
  }

  .page-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;

    > header {
      flex: 0 0 auto;
    }

    .grid-container {
      flex: 1 1 auto;
      min-height: 0;
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(auto-fit, 42%);
      grid-auto-rows: max-content;
      align-content: start;
      justify-content: center;
      text-align: center;
      position: relative;
      overflow-x: hidden;
      overflow-y: auto;
      height: auto;
      padding: 20px 0 32px;
      box-sizing: border-box;
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }

      .card-thumbnail {
        display: block;
        cursor: pointer;
        position: relative;
        text-align: center;
        font-weight: 600;
        text-decoration: none;
        font-size: 15px;
        padding-bottom: 8px;
        color: #000;
        text-shadow: none;
      }
    }
  }
  .content {
    width: 90%;
    height: 70%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    iframe {
      height: 100%;
      width: 100%;
    }
  }

`
